const parser = require('./parser');
const CI = require('./ci');
const { OrionCalculationEngineError, isObject, getProperty, executeFunction, getVariable } = require('./utils');

const CalculationExec = (code, { data, variableMap, libraries, rounding = null}) => {
    if (!code) {
      throw new OrionCalculationEngineError('Expected code to be executed');
    }

    if (!isObject(variableMap)) {
      throw new OrionCalculationEngineError('Expected variableMap object');
    }
 
    if (!isObject(data)) {
      throw new OrionCalculationEngineError('Expected data object');
    }
 
    if (!isObject(libraries) || !isObject(libraries.mathjs)) {
      throw new OrionCalculationEngineError('Expected mathjs library');
    }

    if (rounding) {
      if (typeof rounding.precision !== "number" || rounding.precision < 0 || rounding.precision > 15) {
        throw new OrionCalculationEngineError('If rounding is defined it has to have numeric "rounding" property between 0 and 15');
      }

      if (['UP', 'DOWN'].indexOf(rounding.mode) === -1) {
        throw new OrionCalculationEngineError('If rounding is defined, its "mode" property has to be "UP" or "DOWN"');
      }
    }
    
    const vars = GetVariables(data, variableMap);
    const ci = new CI(libraries.mathjs);

    let result = parser.parse(code, { vars: vars, libraries: {...libraries, ci: ci}, executeFunction: executeFunction, getVariable: getVariable });
    if (rounding) {
        result = ci.round(result, rounding.precision, rounding.mode)
    }
  
    if (Number.isNaN(result)) {
      throw new OrionCalculationEngineError('Result is Not a Number', 'DataError', vars);
    }

    if (result === Infinity) {
      throw new OrionCalculationEngineError('Result is Infinite', 'DataError', vars);
    }

    if (result === -Infinity) {
      throw new OrionCalculationEngineError('Result is Minus Infinite', 'DataError', vars);
    }

    return {result: result, answers: vars};
};

const GetVariables = (data, variableMap) => {
    let vars = {};
    let emptyVars = [];

    for (let i in variableMap) {
        let value = getProperty(data, variableMap[i].value);
        if (value === null || value === undefined || value === "") {
          value = variableMap[i].defaultValue;
        }
        vars[variableMap[i].key] = value;
        if (vars[variableMap[i].key] === '' || vars[variableMap[i].key] === null || vars[variableMap[i].key] === undefined) {
          emptyVars.push(variableMap[i].key);
        }
    }
    if(emptyVars.length) {
      throw new OrionCalculationEngineError('Question(s) “'+ emptyVars.join('", "') +'“ Answer Missing', 'DataError');

    }
    return vars;
};

module.exports = {
  CalculationExec,
};